import { gql } from "graphql-request";

const DeleteProfileQuery = gql`
  mutation DeleteProfile($id: Int!) {
    DeleteProfile(id: $id) {
      status
      error
      messege
    }
  }
`;
export default DeleteProfileQuery;
